import styled from "styled-components/macro";

// Holds a status icon beside a line of result text. The fonts center capitals
// in the line box; the 1px drop centers the icon on the lowercase letters.
export const StatusIconSlot = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: none;
  height: 20px;
  transform: translateY(1px);

  svg {
    height: 16px;
    width: 16px;
  }
`;
